import React, { Component, Fragment } from 'react'

import Label from '../../../components/atoms/Label';
import TextBox from '../../../components/atoms/TextBox';
import Button from '../../../components/atoms/Button';

import checkFormInput from '../../../utils/helpers/checkFormInput'
import { checkEmail, checkRePassword, checkPassword } from '../../../utils/constants/typeCheckFormInput';

class StepEmail extends Component {
    constructor(props){
        super(props)

        this.state = {
            email_regist : {
                value : '',
                type : checkEmail,
                isError : false,
                msg : ''
            },
            pass_regist : {
                value : '',
                type : checkPassword,
                isError : false,
                msg : ''
            },
            repass : {
                value : '',
                type : checkRePassword,
                isError : false,
                msg : ''
            }
        }
    }

    updateState = ({name, value}) => {
        this.setState({
            [name] :  {
                ...this.state[name],
                ...checkFormInput(value, this.state[name].type)
            }
        });
    }

    submitEmail = () => {
        const {email_regist, pass_regist} = this.state;
        const {RegisterEmail, regState} = this.props;

        const data = {
            registration : {
                email : email_regist.value,
                password : pass_regist.value,
                termsConditionAgreement : true,
                newsletterSubscription : true
            }
        }
        
        if(email_regist.value !== '' && pass_regist.value !== '') {
            RegisterEmail({data : data, token : regState.token}).then(res => {
                if(!res){
                    this.setState({
                        isError : true,
                        msg : this.props.status.error
                    })
                }
            })
        }
    }
    

    render() {
        const {email_regist, pass_regist, repass} = this.state;
        return (
            <Fragment>
                <div className='form-regisiter d-flex align-items-center justify-content-center flex-column'>
                    <div className='form-group mt-2'>
                        <Label type='label' for='email_regist' value='Email' className='label-kc-s require' />
                        <TextBox name='email_regist' className='mt-2' value={email_regist.value} onChange={(e) => this.updateState(e.target)} type='email' isFullWidth={true} />
                        { email_regist.isError && <Label type='note' className='red mt-2' value={email_regist.msg} /> }
                    </div>

                    <div className='form-group'>
                        <Label type='label' for='pass_regist' value='Kata Sandi' className='label-kc-s require' />
                        <TextBox name='pass_regist' className='mt-2'  value={pass_regist.value} onChange={(e) => this.updateState(e.target)} type='password' isFullWidth={true} />
                        { pass_regist.isError && <Label type='note' className='red  mt-2' value={pass_regist.msg} /> }
                    </div>

                    <div className='form-group'>
                        <Label type='label' for='re-pass' value='Konfirmasi Kata Sandi' className='label-kc-s require' />
                        <TextBox name='repass' className='mt-2' value={repass.value} onChange={(e) => this.updateState({
                            name : e.target.name, value : {
                                pass : pass_regist.value,
                                repass : e.target.value
                            }
                        })} type='password' isFullWidth={true} />
                        { repass.isError && <Label type='note' className='red mt-2' value={repass.msg} /> }
                    </div>
                </div>

                <Button type='submit' title='KIRIM KODE OTP' isDisabled={(email_regist.isError || repass.isError || email_regist.value === '' || pass_regist.value === '' || repass.value === '') ? true : false} loading={this.props.status.loading} className="mt-3" onClick={this.submitEmail} color='blue' width='block'/>
                <Label type='note' className='red mt-2 d-block' value={this.props.status.error} />
            </Fragment>
        )
    }
}

export default StepEmail;